import { Modal, Box, TextField, Button, Typography, Divider, Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DateRangeIcon from '@mui/icons-material/DateRange';

const days = [
  { id: 'mon', label: 'Пн' },
  { id: 'tue', label: 'Вт' },
  { id: 'wed', label: 'Ср' },
  { id: 'thu', label: 'Чт' },
  { id: 'fri', label: 'Пт' },
  { id: 'sat', label: 'Сб' },
  { id: 'sun', label: 'Вс' }
];

export default function ScheduleSelector({ schedule, onChange }) {
  const toggleDay = (day) => {
    const isWorkDay = schedule.workDays.includes(day);
    const newWorkDays = isWorkDay 
      ? schedule.workDays.filter(d => d !== day)
      : [...schedule.workDays, day];
    
    onChange({
      ...schedule,
      workDays: newWorkDays,
      restDays: days
        .map(d => d.id)
        .filter(id => !newWorkDays.includes(id))
    });
  };

	if (!schedule || !schedule.workDays) {
		return <div>Загрузка расписания...</div>;
	}

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        <DateRangeIcon sx={{ mr: 1 }} />
        Рабочие дни
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        {days.map(day => (
          <Chip
            key={day.id}
            label={day.label}
            onClick={() => toggleDay(day.id)}
            color={schedule.workDays.includes(day.id) ? 'primary' : 'default'}
            variant={schedule.workDays.includes(day.id) ? 'filled' : 'outlined'}
          />
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        <AccessTimeIcon sx={{ mr: 1 }} />
        График работы
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <TextField
          label="Начало"
          type="time"
          value={schedule.dailyHours.start}
          onChange={(e) => onChange({
            ...schedule,
            dailyHours: { ...schedule.dailyHours, start: e.target.value }
          })}
        />
        
        <TextField
          label="Обед с"
          type="time"
          value={schedule.dailyHours.breakStart}
          onChange={(e) => onChange({
            ...schedule,
            dailyHours: { ...schedule.dailyHours, breakStart: e.target.value }
          })}
        />
        
        <TextField
          label="до"
          type="time"
          value={schedule.dailyHours.breakEnd}
          onChange={(e) => onChange({
            ...schedule,
            dailyHours: { ...schedule.dailyHours, breakEnd: e.target.value }
          })}
        />
        
        <TextField
          label="Конец"
          type="time"
          value={schedule.dailyHours.end}
          onChange={(e) => onChange({
            ...schedule,
            dailyHours: { ...schedule.dailyHours, end: e.target.value }
          })}
        />
      </Box>
    </Box>
  );
}